import { NotFoundPage } from './components/404/404.component';
import { AuxUrlComponent } from './components/auxUrl/auxUrl.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { TramitesComponent } from './components/tramites/tramites.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TopMenuComponent } from './components/menu/top-menu/topmenu.component';
import { routing, appRoutingProviders } from './app.routing';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { MenuComponent } from './components/menu/menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ClaveUnicaComponent } from 'src/app/components/claveunica/claveunica.component';
import { ClaveUnicaTokenComponent } from 'src/app/components/claveunica/token/claveunica_token.component';
import { TabsComponent } from './components/formulario/tabs/tabs.component';
import { FileUploadModule } from 'ng2-file-upload';
import { EscapeHtmlPipe } from './pipes/keep-html.pipe';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { BorradoresComponent } from './components/borradores/borradores.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CommonModule } from '@angular/common';
import { Ng2Rut } from 'ng2-rut';
import { HttpClientModule } from '@angular/common/http';

//ArcWizard
import { ArchwizardModule } from 'angular-archwizard';
import { NavbarModule } from './components/navbar/navbar.module';
import { RegistroComponent } from './components/home/registro/registro.component';

import { ToastrModule } from 'ngx-toastr';
//Angular material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS
} from '@angular/material';
import { OptionFormComponent } from './components/option-form/option-form.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';
import { formReducer } from './reducers/forms.reducer';
import { notificationReducer } from './reducers/notification.recuder';

import { FilterPipe2 } from './pipes/filter.pipe2';
import { NgxSpinnerModule } from 'ngx-spinner';

import { TakePhotoComponent } from './components/perfil/takePhoto/takePhoto.component';
import { CertificadosComponent } from './components/certificados/certificados.component';
import { SolicitudesExpComponent } from 'src/app/components/solicitudesexp/solicitudesexp.component';

import { Navbar_certComponent } from './components/certificados/navbar_cert/navbar_cert.component';
import { Navbar_certModule } from './components/certificados/navbar_cert/navbar_cert.module';
import { LottieAnimationViewModule } from 'ng-lottie';
import { SidenavService } from './services/sidenav.service';
import { BorradorStorageService } from './services/borrador-storage.service'
import { crearBorradorComponent } from './components/borradores/crearBorrador/crearBorrador.component';
import { NgxdModule } from '@ngxd/core';
import { ItemsComponent } from './components/items/items.component';
import { AuxUrlcertComponent } from './components/auxUrlcert/auxUrlcert.component';
import { SegCertProvComponent } from './components/seg-cert-prov/seg-cert-prov.component';

//SEGUIMIENTO EXPEDIENTE
import { Seguimiento_expedienteComponent } from './components/seguimiento_expediente/seguimiento_expediente.component';
import { Acta_expedienteComponent } from './components/seguimiento_expediente/acta_expediente/acta_expediente.component';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { PresentacionComponent } from './components/presentacion/presentacion.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { finalFormReducer } from './reducers/form_final.reducer';
import { ForgotPassComponent } from './components/home/forgot-pass/forgot-pass.component';
import { PagoDerechosComponent } from './components/pago-derechos/pago-derechos.component';
import { SocketPagosService } from './services/socket-pagos.service';
import { SocketIoModule, SocketIoConfig, Socket } from 'ngx-socket-io';
import { Solicitud_certificadosComponent } from './components/solicitud_certificados/solicitud_certificados.component';
import { IngresoObservacionesComponent } from './components/ingreso-observaciones/ingreso-observaciones.component';
import { SeguimientoExpComponent } from './components/seguimiento-exp/seguimiento-exp.component';
import { SeguimientoCertificadosComponent } from './components/seguimiento-certificados/seguimiento-certificados.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { IngresoAscensoresComponent } from './components/ascensores/ingreso-ascensores/ingreso-ascensores.component';
import { MantencionAscensoresComponent } from './components/ascensores/mantencion-ascensores/mantencion-ascensores.component';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    ForgotPassComponent,
    ItemsComponent,
    EscapeHtmlPipe,
    OrderByPipe,
    AppComponent,
    HomeComponent,
    MenuComponent,
    TopMenuComponent,
    TramitesComponent,
    ClaveUnicaComponent,
    ClaveUnicaTokenComponent,
    TabsComponent,
    NavbarComponent,
    CertificadosComponent,
    InstructionsComponent,
    MainNavComponent,
    BorradoresComponent,
    OptionFormComponent,
    RegistroComponent,
    InicioComponent,
    FilterPipe2,
    PerfilComponent,
    TakePhotoComponent,
    AuxUrlComponent,
    AuxUrlcertComponent,
    SolicitudesExpComponent,
    Navbar_certComponent,
    NotFoundPage,
    crearBorradorComponent,
    Seguimiento_expedienteComponent,
    Acta_expedienteComponent,
    PresentacionComponent,
    PagoDerechosComponent,
    Solicitud_certificadosComponent,
    SeguimientoExpComponent,
    IngresoObservacionesComponent,
    IngresoAscensoresComponent,
    MantencionAscensoresComponent,
    SeguimientoCertificadosComponent,
    SegCertProvComponent
  ],
  imports: [
    BrowserModule,
    Ng2Rut,
    NgxPaginationModule,
    Nl2BrPipeModule,
    routing,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    ArchwizardModule,
    CommonModule,
    NavbarModule,
    Navbar_certModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxSpinnerModule,
    HttpClientModule,
    SocketIoModule,
    LottieAnimationViewModule.forRoot(),
    StoreModule.forRoot({ form: formReducer, contador: notificationReducer, formFinal: finalFormReducer }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    EffectsModule.forRoot([AppEffects]),
    ToastrModule.forRoot(),
    NgxdModule
  ],
  entryComponents: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    TramitesComponent,
    TopMenuComponent,
    ClaveUnicaComponent,
    ClaveUnicaTokenComponent,
    InstructionsComponent,
    TabsComponent,
    BorradoresComponent,
    OptionFormComponent,
    RegistroComponent,
    InicioComponent,
    PerfilComponent,
    TakePhotoComponent,
    AuxUrlComponent,
    AuxUrlcertComponent,
    CertificadosComponent,
    SolicitudesExpComponent,
    Navbar_certComponent,
    NotFoundPage,
    crearBorradorComponent,
    Seguimiento_expedienteComponent,
    Acta_expedienteComponent,
    IngresoObservacionesComponent,
    IngresoAscensoresComponent,
    MantencionAscensoresComponent,

  ],
  providers: [appRoutingProviders,
    SocketPagosService,
    // { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    SidenavService,
    BorradorStorageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
